<div class="td-wb-symbol-lookup__container"
     (focusin)="onFocusIn()"
     (focusout)="onFocusOut($event)">
  <div class="td-wb-symbol-lookup__input-container">
    <div id="td-wb-symbol-lookup-live-aria"
         class="td-wb-vh"
         aria-live="polite"
         [innerHTML]="focusOnInput() && displayLabelRecentSearches() ? ('tdWb.components.symbolLookup.RECENT_SEARCH_ACCESSIBILITY' | tdWbTranslate) : ''">
    </div>
    <input #symbolLookupInput
           type="text"
           matInput
           [id]="name()"
           [name]="name() + '_symbolOrNameInput'"
           [formControl]="symbolLookupFormControl"
           (input)="inputChange(symbolLookupInput.value)"
           (focus)="setRecentSearches(symbolLookupInput.value)"
           (blur)="inputBlur()"
           [attr.aria-labelledby]="formField?.getLabelId()"
           [attr.aria-describedby]="describedbyIds()"
           [matAutocomplete]="auto"
           [matAutocompleteConnectedTo]="autocompleteOrigin() ?? undefined">
    <mat-autocomplete #auto="matAutocomplete"
                      panelWidth="fit-content"
                      [autoActiveFirstOption]="preSelectFirstItem()"
                      [displayWith]="customDisplayFn() ?? displayFn"
                      (optionSelected)="optionSelected($event?.option?.value)">
      @if (displayLabelRecentSearches()) {
        <div class="td-wb-symbol-lookup-recent-search-label"
             translate="tdWb.components.symbolLookup.RECENT_SEARCH"
             [attr.aria-label]="'tdWb.components.symbolLookup.RECENT_SEARCH' | tdWbTranslate">
        </div>
      }
      @for (item of symbols(); track $index) {
        <mat-option [value]="item">
          <ng-container [ngTemplateOutlet]="customTemplate() ?? defaultTypeAheadTemplate"
                        [ngTemplateOutletContext]="{ $implicit: item, inputValue: getStringInput() }" />
          <ng-template #defaultTypeAheadTemplate
                       let-item
                       let-inputValue="inputValue">
            <td-wb-symbol-lookup-item-label [item]="item"
                                            [highlight]="inputValue"
                                            [compact]="compactSymbolLabel()" />
          </ng-template>
        </mat-option>
      }
    </mat-autocomplete>
  </div>
  <button mat-icon-button
          class="td-wb-symbol-lookup__button"
          matSuffix
          [attr.id]="name() + '_search-button'"
          [name]="name() + '_searchButton'"
          [attr.aria-label]="'tdWb.components.symbolLookup.SEARCH' | tdWbTranslate"
          [disabled]="disabled"
          (click)="onSearchButtonClicked()"
          [attr.readonly]="disabled">
    <mat-icon fontIcon="td-icon-search" class="td-wb-symbol-lookup__icon" />
  </button>
</div>
